export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=65b430c6&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/agents/agent/index.vue?vue&type=template&id=65b430c6&scoped=true
// module id = 4QIm
// module chunks = 0